import React from 'react'
import styled, { keyframes } from 'styled-components'

interface MovingTextProps {
  text: string
  duration?: string
}

const marqueeAnimation = keyframes`
  0% { transform: translateX(0%); }
  100% { transform: translateX(100%); }
`

const Container = styled.div`
  height: 2rem;
  background-color: red;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  position: relative;
`

const Text = styled.div<{ duration: string }>`
  position: absolute;
  white-space: nowrap;
  color: white;
  font-weight: 600;
  animation: ${({ duration }) => marqueeAnimation} ${({ duration }) => duration}
    linear infinite;
`

const MovingText: React.FC<MovingTextProps> = ({ text, duration = '5s' }) => {
  return (
    <Container>
      <Text duration={duration} color="neutral-color">
        {text}
      </Text>
    </Container>
  )
}

export default MovingText
